
export interface JoomlaVersion {
  version: string;
  release_date: string;
  eol_date: string;
  status: "Active" | "EOL" | "Upcoming";
}

export const joomlaVersions: JoomlaVersion[] = [
    {
    "version": "1.0.0",
    "release_date": "2005-08-17",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.1",
    "release_date": "2005-09-02",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.2",
    "release_date": "2005-09-14",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.3",
    "release_date": "2005-09-30",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.4",
    "release_date": "2005-10-06",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.5",
    "release_date": "2005-10-21",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.6",
    "release_date": "2005-11-02",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.7",
    "release_date": "2005-11-21",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.8",
    "release_date": "2005-12-09",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.9",
    "release_date": "2006-01-03",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.10",
    "release_date": "2006-01-30",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.11",
    "release_date": "2006-03-06",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.12",
    "release_date": "2006-05-22",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.13",
    "release_date": "2007-02-14",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.0.15",
    "release_date": "2008-02-08",
    "eol_date": "2009-07-22",
    "status": "EOL"
  },
  {
    "version": "1.5.0",
    "release_date": "2008-01-22",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.1",
    "release_date": "2008-02-08",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.2",
    "release_date": "2008-03-07",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.3",
    "release_date": "2008-04-22",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.4",
    "release_date": "2008-06-11",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.5",
    "release_date": "2008-07-22",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.6",
    "release_date": "2008-08-12",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.7",
    "release_date": "2008-09-25",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.8",
    "release_date": "2008-11-03",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.9",
    "release_date": "2009-01-27",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.10",
    "release_date": "2009-03-03",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.11",
    "release_date": "2009-04-28",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.12",
    "release_date": "2009-06-18",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.13",
    "release_date": "2009-07-22",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.14",
    "release_date": "2009-09-01",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.15",
    "release_date": "2009-10-28",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.16",
    "release_date": "2009-12-10",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.17",
    "release_date": "2010-02-05",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.18",
    "release_date": "2010-03-30",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.19",
    "release_date": "2010-05-20",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.20",
    "release_date": "2010-07-07",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.21",
    "release_date": "2010-08-10",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.22",
    "release_date": "2010-10-27",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.23",
    "release_date": "2011-01-06",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.24",
    "release_date": "2011-03-29",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.25",
    "release_date": "2011-06-30",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "1.5.26",
    "release_date": "2012-01-24",
    "eol_date": "2012-09-30",
    "status": "EOL"
  },
  {
    "version": "2.5.0",
    "release_date": "2012-01-24",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.1",
    "release_date": "2012-02-27",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.2",
    "release_date": "2012-03-27",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.3",
    "release_date": "2012-04-26",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.4",
    "release_date": "2012-05-29",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.5",
    "release_date": "2012-06-26",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.6",
    "release_date": "2012-07-24",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.7",
    "release_date": "2012-08-28",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.8",
    "release_date": "2012-09-25",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.9",
    "release_date": "2012-10-30",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.10",
    "release_date": "2012-11-27",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.11",
    "release_date": "2013-01-08",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.12",
    "release_date": "2013-02-26",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.13",
    "release_date": "2013-03-26",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.14",
    "release_date": "2013-04-30",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.15",
    "release_date": "2013-05-28",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.16",
    "release_date": "2013-06-25",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.17",
    "release_date": "2013-07-30",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.18",
    "release_date": "2013-08-27",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.19",
    "release_date": "2013-09-24",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.20",
    "release_date": "2013-10-29",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.21",
    "release_date": "2013-11-26",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.22",
    "release_date": "2014-01-07",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.23",
    "release_date": "2014-02-25",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.24",
    "release_date": "2014-03-25",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.25",
    "release_date": "2014-04-29",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.26",
    "release_date": "2014-05-27",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.27",
    "release_date": "2014-06-24",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "2.5.28",
    "release_date": "2014-07-29",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "3.0.0",
    "release_date": "2012-09-27",
    "eol_date": "2014-03-06",
    "status": "EOL"
  },
  {
    "version": "3.0.1",
    "release_date": "2012-10-11",
    "eol_date": "2014-03-06",
    "status": "EOL"
  },
  {
    "version": "3.0.2",
    "release_date": "2012-11-06",
    "eol_date": "2014-03-06",
    "status": "EOL"
  },
  {
    "version": "3.0.3",
    "release_date": "2012-12-06",
    "eol_date": "2014-03-06",
    "status": "EOL"
  },
  {
    "version": "3.0.4",
    "release_date": "2013-01-08",
    "eol_date": "2014-03-06",
    "status": "EOL"
  },
  {
    "version": "3.1.0",
    "release_date": "2013-04-24",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "3.1.1",
    "release_date": "2013-05-09",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "3.1.2",
    "release_date": "2013-05-28",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "3.1.3",
    "release_date": "2013-06-25",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "3.1.4",
    "release_date": "2013-07-30",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "3.1.5",
    "release_date": "2013-08-27",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "3.1.6",
    "release_date": "2013-09-24",
    "eol_date": "2014-12-31",
    "status": "EOL"
  },
  {
    "version": "3.2.0",
    "release_date": "2013-11-06",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.2.1",
    "release_date": "2013-11-26",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.2.2",
    "release_date": "2014-01-07",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.2.3",
    "release_date": "2014-02-25",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.3.0",
    "release_date": "2014-04-30",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.3.1",
    "release_date": "2014-05-27",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.3.2",
    "release_date": "2014-06-24",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.3.3",
    "release_date": "2014-07-29",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.3.4",
    "release_date": "2014-08-26",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.3.5",
    "release_date": "2014-09-30",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.3.6",
    "release_date": "2014-10-28",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.0",
    "release_date": "2015-02-24",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.1",
    "release_date": "2015-03-25",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.2",
    "release_date": "2015-04-28",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.3",
    "release_date": "2015-05-26",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.4",
    "release_date": "2015-06-30",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.5",
    "release_date": "2015-07-28",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.6",
    "release_date": "2015-08-25",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.7",
    "release_date": "2015-09-29",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.4.8",
    "release_date": "2015-10-27",
    "eol_date": "2016-03-21",
    "status": "EOL"
  },
  {
    "version": "3.5.0",
    "release_date": "2016-03-21",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.5.1",
    "release_date": "2016-04-26",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.6.0",
    "release_date": "2016-07-12",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.6.1",
    "release_date": "2016-08-09",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.6.2",
    "release_date": "2016-09-13",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.6.3",
    "release_date": "2016-10-11",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.6.4",
    "release_date": "2016-11-08",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.6.5",
    "release_date": "2016-12-13",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.7.0",
    "release_date": "2017-04-25",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.7.1",
    "release_date": "2017-05-30",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.7.2",
    "release_date": "2017-06-27",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.7.3",
    "release_date": "2017-07-25",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.7.4",
    "release_date": "2017-08-29",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.7.5",
    "release_date": "2017-09-26",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.0",
    "release_date": "2017-09-19",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.1",
    "release_date": "2017-10-31",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.2",
    "release_date": "2017-11-28",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.3",
    "release_date": "2017-12-12",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.4",
    "release_date": "2018-01-30",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.5",
    "release_date": "2018-02-27",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.6",
    "release_date": "2018-03-27",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.7",
    "release_date": "2018-04-24",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.8",
    "release_date": "2018-05-29",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.9",
    "release_date": "2018-06-26",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.10",
    "release_date": "2018-07-31",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.8.11",
    "release_date": "2018-08-28",
    "eol_date": "2018-09-18",
    "status": "EOL"
  },
  {
    "version": "3.9.0",
    "release_date": "2018-10-30",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.1",
    "release_date": "2018-11-27",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.2",
    "release_date": "2018-12-18",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.3",
    "release_date": "2019-01-29",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.4",
    "release_date": "2019-02-26",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.5",
    "release_date": "2019-03-26",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.6",
    "release_date": "2019-04-30",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.7",
    "release_date": "2019-05-28",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.8",
    "release_date": "2019-06-25",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.9",
    "release_date": "2019-07-30",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.10",
    "release_date": "2019-08-27",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.11",
    "release_date": "2019-09-24",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.12",
    "release_date": "2019-10-29",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.13",
    "release_date": "2019-11-26",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.14",
    "release_date": "2020-01-07",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.15",
    "release_date": "2020-02-25",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.16",
    "release_date": "2020-03-24",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.17",
    "release_date": "2020-04-28",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.18",
    "release_date": "2020-05-26",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.19",
    "release_date": "2020-06-30",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.20",
    "release_date": "2020-07-28",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.21",
    "release_date": "2020-08-25",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.22",
    "release_date": "2020-10-29",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.23",
    "release_date": "2020-11-26",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.24",
    "release_date": "2021-01-07",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.25",
    "release_date": "2021-02-25",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.26",
    "release_date": "2021-03-24",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.27",
    "release_date": "2021-04-28",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.28",
    "release_date": "2021-05-26",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.9.29",
    "release_date": "2021-06-23",
    "eol_date": "2021-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.0",
    "release_date": "2021-08-17",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.1",
    "release_date": "2021-09-14",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.2",
    "release_date": "2021-10-12",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.3",
    "release_date": "2021-11-09",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.4",
    "release_date": "2021-12-14",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.5",
    "release_date": "2022-01-11",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.6",
    "release_date": "2022-02-08",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.7",
    "release_date": "2022-03-08",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.8",
    "release_date": "2022-04-12",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.9",
    "release_date": "2022-05-10",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.10",
    "release_date": "2022-06-14",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.11",
    "release_date": "2022-07-12",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
  {
    "version": "3.10.12",
    "release_date": "2022-08-16",
    "eol_date": "2023-08-17",
    "status": "EOL"
  },
    {
      "version": "4.0.0",
      "release_date": "2021-08-17",
      "eol_date": "2023-10-17",
      "status": "EOL"
    },
    {
      "version": "4.0.1",
      "release_date": "2021-08-23",
      "eol_date": "2023-10-17",
      "status": "EOL"
    },
    {
      "version": "4.0.2",
      "release_date": "2021-08-24",
      "eol_date": "2023-10-17",
      "status": "EOL"
    },
    {
      "version": "4.0.3",
      "release_date": "2021-09-14",
      "eol_date": "2023-10-17",
      "status": "EOL"
    },
    {
      "version": "4.0.4",
      "release_date": "2021-10-24",
      "eol_date": "2023-10-17",
      "status": "EOL"
    },
    {
      "version": "4.0.5",
      "release_date": "2021-12-05",
      "eol_date": "2023-10-17",
      "status": "EOL"
    },
    {
      "version": "4.0.6",
      "release_date": "2022-01-18",
      "eol_date": "2023-10-17",
      "status": "EOL"
    },
    {
      "version": "4.1.0",
      "release_date": "2022-02-15",
      "eol_date": "2022-08-15",
      "status": "EOL"
    },
    {
      "version": "4.1.1",
      "release_date": "2022-03-29",
      "eol_date": "2022-08-15",
      "status": "EOL"
    },
    {
      "version": "4.1.2",
      "release_date": "2022-03-30",
      "eol_date": "2022-08-15",
      "status": "EOL"
    },
    {
      "version": "4.1.3",
      "release_date": "2022-05-07",
      "eol_date": "2022-08-15",
      "status": "EOL"
    },
    {
      "version": "4.1.4",
      "release_date": "2022-05-24",
      "eol_date": "2022-08-15",
      "status": "EOL"
    },
    {
      "version": "4.1.5",
      "release_date": "2022-06-21",
      "eol_date": "2022-08-15",
      "status": "EOL"
    },
    {
      "version": "4.2.0",
      "release_date": "2022-08-16",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.1",
      "release_date": "2022-08-30",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.2",
      "release_date": "2022-09-02",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.3",
      "release_date": "2022-09-27",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.4",
      "release_date": "2022-10-25",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.5",
      "release_date": "2022-11-07",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.6",
      "release_date": "2022-12-12",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.7",
      "release_date": "2023-01-30",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.8",
      "release_date": "2023-02-16",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.2.9",
      "release_date": "2023-03-14",
      "eol_date": "2023-02-16",
      "status": "EOL"
    },
    {
      "version": "4.3.0",
      "release_date": "2023-04-18",
      "eol_date": "2023-08-16",
      "status": "EOL"
    },
    {
      "version": "4.3.1",
      "release_date": "2023-05-02",
      "eol_date": "2023-08-16",
      "status": "EOL"
    },
    {
      "version": "4.3.2",
      "release_date": "2023-05-30",
      "eol_date": "2023-08-16",
      "status": "EOL"
    },
    {
      "version": "4.3.3",
      "release_date": "2023-07-11",
      "eol_date": "2023-08-16",
      "status": "EOL"
    },
    {
      "version": "4.3.4",
      "release_date": "2023-08-22",
      "eol_date": "2023-08-16",
      "status": "EOL"
    },
    {
      "version": "4.4.0",
      "release_date": "2023-10-17",
      "eol_date": "2024-02-16",
      "status": "Active"
    },
    {
      "version": "4.4.1",
      "release_date": "2023-11-28",
      "eol_date": "2024-02-16",
      "status": "Active"
    },
    {
      "version": "4.4.2",
      "release_date": "2024-01-09",
      "eol_date": "2024-02-16",
      "status": "Active"
    },
    {
      "version": "4.4.3",
      "release_date": "2024-02-20",
      "eol_date": "2024-02-16",
      "status": "Active"
    },
    {
      "version": "4.4.4",
      "release_date": "2024-04-16",
      "eol_date": "2024-08-16",
      "status": "Active"
    },
    {
      "version": "4.4.5",
      "release_date": "2024-05-28",
      "eol_date": "2024-08-16",
      "status": "Active"
    },
    {
      "version": "4.4.6",
      "release_date": "2024-07-09",
      "eol_date": "2024-08-16",
      "status": "Active"
    },
    {
      "version": "4.4.7",
      "release_date": "2024-08-20",
      "eol_date": "2024-08-16",
      "status": "Active"
    },
    {
      "version": "4.4.8",
      "release_date": "2024-08-27",
      "eol_date": "2024-08-16",
      "status": "Active"
    },
    {
      "version": "4.4.9",
      "release_date": "2024-10-15",
      "eol_date": "2025-02-16",
      "status": "Active"
    },
    {
      "version": "4.4.10",
      "release_date": "2025-01-07",
      "eol_date": "2025-02-16",
      "status": "Active"
    },
    {
      "version": "4.4.11",
      "release_date": "2025-02-18",
      "eol_date": "2025-02-16",
      "status": "Active"
    },

  {
    "version": "5.0.0",
    "release_date": "2023-10-17",
    "eol_date": "2027-10-12",
    "status": "Active"
  },
  {
    "version": "5.0.1",
    "release_date": "2023-11-28",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.0.2",
    "release_date": "2024-01-09",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.0.3",
    "release_date": "2024-02-20",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.1.0",
    "release_date": "2024-04-16",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.1.1",
    "release_date": "2024-05-28",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.1.2",
    "release_date": "2024-07-09",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.1.3",
    "release_date": "2024-08-20",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.1.4",
    "release_date": "2024-08-27",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.2.0",
    "release_date": "2024-10-15",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.2.1",
    "release_date": "2024-11-07",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.2.2",
    "release_date": "2024-11-26",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.2.3",
    "release_date": "2025-01-06",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.2.4",
    "release_date": "2025-02-17",
    "eol_date": "TBD",
    "status": "Active"
  },
  {
    "version": "5.3.0 Beta 2",
    "release_date": "2025-03-04",
    "eol_date": "TBD",
    "status": "Upcoming"
  },
];

// Helper functions for working with Joomla versions

/**
 * Get all major versions (x.0.0 or x.5.0)
 */
export function getMajorVersions(): JoomlaVersion[] {
  return joomlaVersions.filter(version => {
    const parts = version.version.split('.');
    return (parts[1] === '0' || parts[1] === '5') && parts[2] === '0';
  });
}

/**
 * Get all active versions
 */
export function getActiveVersions(): JoomlaVersion[] {
  return joomlaVersions.filter(version => version.status === "Active");
}

/**
 * Get the latest stable version
 */
export function getLatestVersion(): JoomlaVersion | undefined {
  const activeVersions = getActiveVersions();
  if (activeVersions.length === 0) return undefined;
  
  return activeVersions.reduce((latest, current) => {
    const latestParts = latest.version.split('.').map(Number);
    const currentParts = current.version.split('.').map(Number);
    
    for (let i = 0; i < Math.max(latestParts.length, currentParts.length); i++) {
      const latestPart = latestParts[i] || 0;
      const currentPart = currentParts[i] || 0;
      if (currentPart > latestPart) return current;
      if (latestPart > currentPart) return latest;
    }
    
    return latest;
  });
}

/**
 * Check if a version is EOL (End of Life)
 */
export function isEOL(version: string): boolean {
  const versionData = joomlaVersions.find(v => v.version === version);
  if (!versionData) return false;
  
  return versionData.status === "EOL";
}

/**
 * Calculate days until EOL or days since EOL
 */
export function calculateEOLStatus(version: string): { 
  days: number; 
  isEol: boolean; 
  message: string 
} {
  const versionData = joomlaVersions.find(v => v.version === version);
  
  if (!versionData || versionData.eol_date === "TBD") {
    return { days: 0, isEol: false, message: "No EOL date available" };
  }
  
  const today = new Date();
  const eolDate = new Date(versionData.eol_date);
  const diffTime = eolDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 0) {
    return { 
      days: Math.abs(diffDays), 
      isEol: true, 
      message: `This version reached end-of-life ${Math.abs(diffDays)} days ago` 
    };
  } else {
    return { 
      days: diffDays, 
      isEol: false, 
      message: `This version will reach end-of-life in ${diffDays} days` 
    };
  }
}

/**
 * Get versions by major version number
 */
export function getVersionsByMajor(majorVersion: string): JoomlaVersion[] {
  return joomlaVersions.filter(version => version.version.startsWith(majorVersion + '.'));
}